import { memo } from 'react';
import { BaseNodeUI } from './BaseNodeUI';
import { Handle, Position } from 'reactflow';
import { Coins } from 'lucide-react';

export default memo(({ data, selected }: any) => {
    return (
        <div className="relative h-full">
            <BaseNodeUI
                title={data.label || 'Currency Conv.'}
                icon={Coins}
                colorClass="text-amber-600"
                bgClass="bg-amber-100/50"
                selected={selected}
                isSource={false}
                isTarget={false}
                hideHandles={true} // Custom handles below
            >
            </BaseNodeUI>

            {/* Custom Handles */}

            {/* Input: Data (Top Left) */}
            <Handle
                type="target"
                position={Position.Left}
                id="in"
                className="!w-3 !h-3 !min-w-0 !min-h-0 !bg-transparent !border-0 flex items-center justify-center z-50 cursor-pointer"
                style={{ left: -14, top: '35%' }}
                title="Data Input"
            >
                <div className="w-1.5 h-1.5 border-t-[2px] border-r-[2px] border-amber-500 rotate-45 transform -translate-x-0.5" />
            </Handle>
            <div className="absolute -left-12 top-[30%] text-[8px] text-gray-400 font-medium">Data</div>

            {/* Input: Rates (Bottom Left) */}
            <Handle
                type="target"
                position={Position.Left}
                id="rates"
                className="!w-3 !h-3 !min-w-0 !min-h-0 !bg-transparent !border-0 flex items-center justify-center z-50 cursor-pointer"
                style={{ left: -14, top: '65%' }}
                title="Rates Input"
            >
                <div className="w-1.5 h-1.5 border-t-[2px] border-r-[2px] border-amber-500 rotate-45 transform -translate-x-0.5" />
            </Handle>
            <div className="absolute -left-12 top-[60%] text-[8px] text-gray-400 font-medium">Rates</div>

            {/* Output (Right) */}
            <Handle
                type="source"
                position={Position.Right}
                id="out"
                className="!w-3 !h-3 !min-w-0 !min-h-0 !bg-transparent !border-0 flex items-center justify-center z-50 cursor-pointer"
                style={{ right: -14, top: '50%', transform: 'translateY(-50%)' }}
            >
                <div className="w-1.5 h-1.5 border-t-[2px] border-r-[2px] border-emerald-500 rotate-45 transform -translate-x-0.5" />
            </Handle>
        </div>
    );
});
